import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { ISelectOptionGroup } from 'projects/bis-shared/src/lib/dynamic-forms/models/select-option-group';
import { SelectHelpers } from 'projects/bis-shared/src/lib/utility/select-helpers';
import { ObjectSubType } from './object-sub-type.model';
import { InternalApiUrls } from 'projects/bis-shared/src/lib/utility/apiurls-internal';

@Injectable({ providedIn: 'root' })
export class ObjectSubTypeService {
  private http = inject(HttpClient);
  private apiUrls = inject(InternalApiUrls);

  
 

  

  getObjectSubTypes(objectType: string): Observable<ISelectOptionGroup[]> {
    return this.http
      .get<ObjectSubType[]>(this.apiUrls.objectSubType.getByObjectType(objectType))
      .pipe(
        map(forms =>
          SelectHelpers.toSelectList(
            forms,
            c => c.objectSubType,
            c => c.objectSubTypeId,
          ),
        ),
      );
  }
}
